import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMemberTrialHistoryData,
  fetchTrialSessionDetailsData,
} from "../../../redux/plans-reducers/plansSlice";
import {
  convertTo12HourFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import CommonTable from "../../common-components/common-tables/CommonTable";
import {
  CalendarIcon,
  CallIcon,
  CheckCircleIcon,
  ClockIconV3,
  EmailIcon,
  PendingIcon,
  PersonIcon,
  XCircleIcon,
} from "../../../images/icons/icons";

const ThreedayTrialHistory = ({ rowData, userInfoData }) => {
  const dispatch = useDispatch();
  const {
    memberTrialHistory,
    memberTrialHistoryLoading,
    memberTrialHistoryError,

    trialSessionDetails,
    trialSessionDetailsLoading,
    trialSessionDetailsError,
  } = useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(5);
  const [sessionPage, setSessionPage] = useState(0);
  const [sessionPageLimit, setSessionPageLimit] = useState(5);
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    user_id: rowData?.user_id || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [isShowSessionDetails, setIsShowSessionDetails] = useState(false);

  const iniDatas = {
    pagination: [],
    allData: [],

    sessionDetails: [],
    sessionDetailsPagination: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  function getMemberTrialHistory(filters) {
    dispatch(
      fetchMemberTrialHistoryData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getTrialSessionHistory(filters) {
    dispatch(
      fetchTrialSessionDetailsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleSessionStatusClick = (rowData) => {
    setSessionPage(0);
    setSelectedSubscriptionId(rowData);
    setSelectedRowId(rowData?.three_day_id);

    setTimeout(() => {
      const sessionDetailsTable = document.getElementById(
        "session-details-table"
      );
      if (sessionDetailsTable) {
        sessionDetailsTable.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }, 100);
  };

  useEffect(() => {
    if (filters?.user_id) {
      getMemberTrialHistory(filters);
    }
  }, [filters]);

  useEffect(() => {
    setSelectedRowId(null);
    setSelectedSubscriptionId(null);
    setIsShowSessionDetails(false);
  }, [rowData?.user_id]);

  useEffect(() => {
    if (selectedSubscriptionId) {
      const sendableFilters = {
        subscription_id: selectedSubscriptionId?.three_day_id || "",
      };

      getTrialSessionHistory(sendableFilters);

      setIsShowSessionDetails(true);
    }
  }, [selectedSubscriptionId]);

  useEffect(() => {
    if (
      !memberTrialHistoryLoading &&
      !memberTrialHistoryError &&
      memberTrialHistory?.status &&
      memberTrialHistory?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: memberTrialHistory.data,
        pagination:
          memberTrialHistory?.pagination?.length > 0
            ? memberTrialHistory.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [memberTrialHistoryLoading, memberTrialHistoryError, memberTrialHistory]);

  useEffect(() => {
    if (
      !trialSessionDetailsLoading &&
      !trialSessionDetailsError &&
      trialSessionDetails?.status &&
      trialSessionDetails?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        sessionDetails: trialSessionDetails.data,
        sessionDetailsPagination:
          trialSessionDetails?.pagination?.length > 0
            ? trialSessionDetails.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        sessionDetails: [],
        sessionDetailsPagination: [],
      }));
    }
  }, [
    trialSessionDetailsLoading,
    trialSessionDetailsError,
    trialSessionDetails,
  ]);

  if (!memberTrialHistoryLoading && allDatas.allData?.length === 0) {
    return (
      <div className="error-container">
        <p>No PT 3 Day Trail logs found for this member.</p>
      </div>
    );
  }

  const tbColumn = [
    {
      dataField: "trainer_name",
      text: "Trainer",
      formatter: (_, row) => (
        <span className="tb-data text-start">
          {row?.trainer_name || "NA"}
          <br />
          {row?.trainer_mobile && (
            <small className="underline lowercase">
              {row?.trainer_mobile || ""}
            </small>
          )}
        </span>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "trainer_status",
      text: "trainer status",
      formatter: (_, row) => {
        const getStatusColor = (status) => {
          switch (status?.toLowerCase()) {
            case "active":
              return { bg: "#D4EDDA", color: "#155724" }; // Green
            case "inactive":
              return { bg: "#F8D7DA", color: "#721C24" }; // Red
            case "pending":
              return { bg: "#FFF3CD", color: "#856404" }; // Yellow
            default:
              return { bg: "#F6EFEF", color: "#666666" }; // Gray
          }
        };
        const colors = getStatusColor(row?.trainer_status);
        return (
          <div
            className="emeberDetailsRowContainer column"
            style={{ alignItems: "flex-start" }}
          >
            <p
              className="info"
              style={{
                background: colors.bg,
                color: colors.color,
                borderRadius: "8px",
                padding: "5px 10px",
              }}
            >
              {row?.trainer_status || "NA"}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "session_status",
      text: "session status",
      formatter: (_, row) => (
        <div
          className="emeberDetailsRowContainer column"
          style={{ alignItems: "flex-start" }}
        >
          <p
            className={`info ${
              selectedRowId === row?.three_day_id ? "selected-row" : ""
            }`}
            style={{
              background:
                selectedRowId === row?.three_day_id ? "#1976d2" : "#FFEDC0",
              color: selectedRowId === row?.three_day_id ? "#fff" : "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
              cursor: "pointer",
              border:
                selectedRowId === row?.three_day_id
                  ? "2px solid #0d47a1"
                  : "none",
              boxShadow:
                selectedRowId === row?.three_day_id
                  ? "0 2px 8px rgba(25, 118, 210, 0.3)"
                  : "none",
              transition: "all 0.2s ease",
            }}
            onClick={() => handleSessionStatusClick(row)}
          >
            {row?.session_status || "NA"}
            {selectedRowId === row?.three_day_id && " ✓"}
          </p>
        </div>
      ),
    },
    {
      dataField: "subscription_status",
      text: "Trial status",
      formatter: (_, row) => {
        const getStatusColor = (status) => {
          switch (status?.toLowerCase()) {
            case "active":
              return { bg: "#D4EDDA", color: "#155724" }; // Green
            case "expired":
            case "inactive":
              return { bg: "#F8D7DA", color: "#721C24" }; // Red
            case "pending":
              return { bg: "#FFF3CD", color: "#856404" }; // Yellow
            default:
              return { bg: "#F6EFEF", color: "#666666" }; // Gray
          }
        };
        const colors = getStatusColor(row?.subscription_status);
        return (
          <div
            className="emeberDetailsRowContainer column"
            style={{ alignItems: "flex-start" }}
          >
            <p
              className="info"
              style={{
                background: colors.bg,
                color: colors.color,
                borderRadius: "8px",
                padding: "5px 10px",
              }}
            >
              {row?.subscription_status || "NA"}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "Trial Duration",
      formatter: (_, row) => (
        <span className="tb-data minWidth100 underline tb-col">
          {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          <br />
          {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "date_added",
      text: "Trial Add Date",
      formatter: (_, row) => (
        <div
          className="emeberDetailsRowContainer column"
          style={{ alignItems: "flex-start" }}
        >
          <p className="info minWidth100 bold">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
  ];

  const sessionTbColumns = [
    {
      dataField: "date",
      text: "session date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <CalendarIcon color="#2c3e50" />
            </span>{" "}
            <span className="tb-data">{row?.date || "-"}</span>
          </div>
        );
      },
    },
    {
      dataField: "date",
      text: "session time",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 color="#2c3e50" />
            </span>{" "}
            <span className="tb-data">
              {convertTo12HourFormat(row?.start_time || "-")} -{" "}
              {convertTo12HourFormat(row?.end_time || "-")}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "session_status",
      text: "session status",
      formatter: (_, row) => {
        return (
          <span className="tb-data tb-icon">
            {row?.session_status === "verified" ? (
              <CheckCircleIcon />
            ) : row?.session_status === "pending" ? (
              <PendingIcon />
            ) : (
              <XCircleIcon />
            )}{" "}
            {row?.session_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "trainer_name",
      text: "trainer name",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <PersonIcon />
            </span>{" "}
            <span className="tb-data">{row?.trainer_name || "NA"}</span>{" "}
          </div>
        );
      },
    },
    {
      dataField: "trainer_mobile",
      text: "trainer mobile",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <CallIcon />
            </span>{" "}
            <span className="tb-data">{row?.trainer_mobile || "NA"}</span>{" "}
          </div>
        );
      },
    },
    {
      dataField: "trainer_email",
      text: "trainer email",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <EmailIcon />
            </span>{" "}
            <span className="tb-data lowercase">
              {row?.trainer_email || "NA"}
            </span>{" "}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={
            allDatas.allData?.length > 10 ? allDatas.pagination : null
          }
          tableColumns={tbColumn}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={memberTrialHistoryLoading}
        />
      </div>

      {isShowSessionDetails && (
        <div id="session-details-table" className="common-table-container mt15">
          <div className="session-details-header">
            <h4
              style={{
                margin: "0 0 15px 0",
                color: "#1976d2",
                fontWeight: "600",
              }}
            >
              Session Details
            </h4>
            <p
              style={{ margin: "0 0 20px 0", color: "#666", fontSize: "14px" }}
            >
              Click on any session status above to view detailed session history
            </p>
          </div>

          <CommonTable
            tableData={allDatas.sessionDetails}
            tablePagination={
              allDatas.sessionDetails?.length > 10
                ? allDatas.sessionDetailsPagination
                : null
            }
            tableColumns={sessionTbColumns}
            isPage={sessionPage}
            setIsPage={setSessionPage}
            pageLimit={sessionPageLimit}
            setPageLimit={setSessionPageLimit}
            isLoading={trialSessionDetailsLoading}
          />
        </div>
      )}

      {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
        {memberTrialHistoryLoading ? (
          <TableSkeleton columns={7} rows={10} />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumn}
            tablePagination={
              allDatas.allData?.length > 10 ? allDatas.pagination : null
            }
            isPage={allDatas.allData?.length > 10 ? isPage : null}
            setIsPage={(value) =>
              allDatas.allData?.length > 10 ? setIsPage(value) : null
            }
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div> */}
    </>
  );
};

export default ThreedayTrialHistory;
